import { Box } from '@mui/material';
import DataCard from 'components/data-card/data-card.component';
import {
  useSearchParamsContext,
  useSearchQueryContext,
} from 'components/search/search.hooks';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

const PasswordlessAuthenticationContent = () => {
  const { t } = useTranslation();

  const {
    searchResults,
    queryState: { isFetching },
  } = useSearchQueryContext();

  const { searchParams: sp, setParamValue } = useSearchParamsContext();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!searchParams.size) {
      setParamValue('startDate', sp.startDate.value);
      setParamValue('endDate', sp.endDate.value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      display="grid"
      gridTemplateColumns={{ xs: 'repeat(1, 1fr)', lg: 'repeat(2, 1fr)' }}
      gap={2}
      data-testid="PasswordlessAuthentication.Content"
    >
      <DataCard
        title={t(
          'page.reportAndAnalytics.smsReports.sections.passwordlessAuthentication.content.smsDelivered',
        )}
        value={searchResults?.[0]?.smsDelivered ?? 0}
        valueType="number"
        loading={isFetching}
        data-testid="PasswordlessAuthenticationSMSDelivered.Card"
      />

      <DataCard
        title={t(
          'page.reportAndAnalytics.smsReports.sections.passwordlessAuthentication.content.percentDelivered',
        )}
        value={searchResults?.[0]?.percentDelivered ?? 0}
        valueType="percent"
        loading={isFetching}
        data-testid="PasswordlessAuthenticationPercentDelivered.Card"
      />
    </Box>
  );
};

export default PasswordlessAuthenticationContent;
